/**
 * Created by staffanrantzow on 15/04/16.
 */

/* @flow */
import React, {PropTypes} from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import Utils from 'frilans-finans/utils/utils';
import { getVatById } from '../../../views/invoice-tool/invoice-tool-helper';
import { toMoney } from '../../invoice-tool/amount/amount-helper';

export class SupplierLedgerRow extends React.Component {

  static propTypes = {
    supplierLedger: PropTypes.object.isRequired,
    hideOrderNumber: PropTypes.bool,
    showDetailColumns: PropTypes.bool
  };

  renderOrderNumber () {
    if (!this.props.hideOrderNumber) {
      return (
        <td className='col-ordernr'>
          <Link
            to={'/economy/invoices/' + this.props.supplierLedger.invoiceId}>{this.props.supplierLedger.invoiceId}
          </Link>
        </td>
      );
    }
  }

  renderDetailArrived () {
    if (this.props.showDetailColumns) {
      return (<td className='col-arrived'>{Utils.formatDate(this.props.supplierLedger.arrivedDate)}</td>);
    }
  }

  renderDetailStatus () {
    if (this.props.showDetailColumns) {
      return (<td className='col-status'>{this.props.supplierLedger.statusText}</td>);
    }
  }

  renderDetailPayed () {
    if (this.props.showDetailColumns) {
      return (<td className='col-paid'>{Utils.formatDate(this.props.supplierLedger.payedDate)}</td>);
    }
  }

  renderLink () {
    var route = '/economy/supplier-ledgers/' + this.props.supplierLedger.id;
    if (this.props.showDetailColumns) {
      return (<Link to={route} className='pointer-link' />);
    }
  }

  render () {
    return (
      <tr>
        <td className='col-levid'>{this.props.supplierLedger.id}</td>
        <td className='col-supplier'>{this.props.supplierLedger.supplierName}</td>
        {this.renderOrderNumber()}
        {this.renderDetailArrived()}
        {this.renderDetailStatus()}
        {this.renderDetailPayed()}
        <td className='col-sum'>
          <span>{toMoney(
              this.props.supplierLedger.amount * (1 + (getVatById(this.props.supplierLedger.taxId) / 100))
            )}
          </span> <Translate content='SEK_SHORT'/>
          {this.renderLink()}
        </td>
      </tr>
    );
  }
}

export default SupplierLedgerRow;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/supplier-ledgers/supplier-ledger-row.js
 **/